import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppSettings } from '../lib/settings';

export const useAppSettings = () => {
  const { search } = useLocation();
  return useMemo(() => getAppSettings(search), [search]);
};
